'use strict';

export const ENV = process.env.NODE_ENV
export const constants = Object.freeze({
  NO_LOADER_NETWORKS: ['LiTv'],
  NO_UMUTE_NETWORKS: ['LiTv', 'OneAd'],
  TEMP_VIEWER_ID: 'TEMP_ID',
  ENV_DEV: 'development',
  ENV_STAGING: 'staging',
  ENV_PROD: 'production',
  S3_BUCKET_PROD: 'wootag-output-beta',
  S3_BUCKET_STAGING: 'wootag-output-beta',

  DEFAULT_BUCKET_ID: '5D031B-E763-3C90',
  DEFAULT_VIDEO_ID: 'AD842E-1AF5-85D6',

  ORIENTATION_PORTRAIT: 'portrait',
  ORIENTATION_LANDSCAPE: 'landscape',

  EDITOR_MODE: 'editorMode',
  DURATION_MODE: 'durationMode',
  CHAPTER_VIEW: 'chapterView',
  PREVIEW_MODE: 'previewMode',
  TAG_OPEN: 'tagOpen',
  TAG_PREVIEW_SMALL_HEIGHT: 480,

  CLICKTHRU_NETWORKS: ['OneAd', 'Xandr/OneAd', 'LiTv'],

  AUTO_EVENT_DELAY: 2000, // delay (in ms) for auto events---
  INTERACTING_EVENT_DELAY: 3000, // delay (in ms) for interacting event fired if tag stays open for this much time---
  INTERACTION_START_EVENT_DELAY: 2000, // delay (in ms) for interaction start event fired if tag stays open for this much time---
  QUARTILE_EVENT_TYPES: ['str', 'frq', 'mid', 'thq', 'com'],
  AGE_GATE_ACCEPTED: 'accepted',
  AGE_GATE_REJECTED: 'rejected',
  LOG_EVENT_CLICK_MANUAL: 'EVT/LOG_EVENT_CLICK_MANUAL',
  LOG_EVENT_CLICK_AUTO: 'EVT/LOG_EVENT_CLICK_AUTO',
  // LOG_EVENT_CLICK_PREVIEW: 'EVT/LOG_EVENT_CLICK_PREVIEW',
  LOG_EVENT_ENGAGEMENT: 'EVT/LOG_EVENT_ENGAGEMENT',
  LOG_EVENT_TAG_OPEN: 'EVT/LOG_EVENT_TAG_OPEN',
  LOG_EVENT_TAG_CLOSE: 'EVT/LOG_EVENT_TAG_CLOSE',
  LOG_EVENT_VIEW: 'EVT/LOG_EVENT_VIEW',
  LOG_EVENT_UNIQUE: 'EVT/LOG_EVENT_UNIQUE',
  LOG_EVENT_UNIQUE_2SEC: 'EVT/LOG_EVENT_UNIQUE_2SEC',
  LOG_EVENT_PLAY: 'EVT/LOG_EVENT_PLAY',
  LOG_EVENT_PAUSE: 'EVT/LOG_EVENT_PAUSE',
  LOG_EVENT_FF: 'EVT/LOG_EVENT_FF',
  LOG_EVENT_VOLUME: 'EVT/LOG_EVENT_VOLUME',
  LOG_EVENT_FOCUS_OUT: 'EVT/LOG_EVENT_FOCUS_OUT',
  LOG_EVENT_FOCUS_IN: 'EVT/LOG_EVENT_FOCUS_IN',
  LOG_EVENT_CONTINUE: 'EVT/LOG_EVENT_CONTINUE',
  LOG_EVENT_REPEAT: 'EVT/LOG_EVENT_REPEAT',
  LOG_EVENT_EMOJI_CLICK: 'EVT/LOG_EVENT_EMOJI_CLICK',
  LOG_EVENT_COMPLETION: 'EVT/LOG_EVENT_COMPLETION',
  LOG_EVENT_QUARTILE: 'EVT/LOG_EVENT_QUARTILE',
  LOG_EVENT_INTERACTING: 'EVT/LOG_EVENT_INTERACTING',
  LOG_EVENT_INTERACTION_START: 'EVT/LOG_EVENT_INTERACTION_START',
  LOG_EVENT_ENDCARD_PREVIEW: 'EVT/LOG_EVENT_ENDCARD_PREVIEW',
  LOG_EVENT_INTERACTION: 'EVT/LOG_EVENT_INTERACTION',
  LOG_EVENT_GALLERY_INTERACTION: 'EVT/LOG_EVENT_GALLERY_INTERACTION',
  LOG_EVENT_FORM_INSIGHT: 'EVT/LOG_EVENT_FORM_INSIGHT',
});

export const config = {
  ver: '3.0.0',
  env: ENV,
  STAGING_DOMAIN: 'https://stagingwt.wootag.com',
  PROD_DOMAIN: 'https://www.wootag.com',
  PREPROD_DOMAIN: 'https://preprod.wootag.com',
  GOOGLE_MAP_KEY: ENV === constants.ENV_DEV ? 'AIzaSyDbAhCZcZEBu25gAsCob9ce_fktiZlAh30' : 'AIzaSyDbAhCZcZEBu25gAsCob9ce_fktiZlAh30',
  DOMAIN: ENV === constants.ENV_DEV ? 'https://stagingwt.wootag.com' : window.location.origin,
  CDN: ENV === constants.ENV_DEV ? 'https://stagecdn.wootag.com' : 'https://cdn.wootag.com',
  S3_BUCKET: ENV === constants.ENV_PROD ? constants.S3_BUCKET_PROD : constants.S3_BUCKET_STAGING,
  DEFAULT_BUCKET_ID: ENV !== constants.ENV_PROD ? constants.DEFAULT_BUCKET_ID : null,
  DEFAULT_VIDEO_ID: ENV !== constants.ENV_PROD ? constants.DEFAULT_VIDEO_ID : null,
  TAG_PREVIEW_INDENT: 40,

  engagementTypes: {
    inVideo: 'In-Video',
    outVideo: 'Out-Video',
    inOutVideo: 'In + Out-Video'
  },

  targets: {
    devices: {
      mobile: 'mobile',
      desktop: 'desktop',
      tablet: 'tablet',
      windows: 'windows',
      macos: 'macos',
      ios: 'ios',
      chromeos: 'chromeos',
      android: 'android',
    }
  }
};

export const links = {
  swiperCSS: 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.4.2/css/swiper.min.css',
  swiperJS: 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.3.3/js/swiper.min.js',
  fontpath: `https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css`,
  typeface: `https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap`,
  getJSON: (bucket, videoId, previewLink) => {
    if (previewLink) {
      return `${config.DOMAIN}/api/v2/datajson/${bucket}/${videoId}?mode=preview`;
    } else {
      return `${config.DOMAIN}/api/v2/datajson/${bucket}/${videoId}`;
    }
  },
  getCaptions: (bucket, videoId) => {
    return `${config.CDN}/${bucket}/${videoId}/captions.json`;
  },
  getAdJSON: (domain, bucket, videoId) => {
    return `${domain}/api/v2/datajson/${bucket}/${videoId}`;
  },
  getUserJSON: (bucketId) => {
    return `${config.DOMAIN}/api/v2/userjson/${bucketId}`;
  },
  sendLogs: (domain) => {
    if (domain) {
      return `${domain}/api/v1/data/track/event`;
    } else {
      return `${config.DOMAIN}/api/v1/data/track/event`;
    }
  },
  submitPoll: (domain) => {
    if (domain) {
      return `${domain}/api/v1/data/polls/polls`;
    } else {
      return `${config.DOMAIN}/api/v1/data/polls/polls`;
    }
  },
  getThirdPartyProductData: ({domain, bucket, videoId, tagId, platform}) => {
    const dom = domain || config.DOMAIN;
    return `${dom}/api/v2/productjson/${bucket}/${videoId}/${platform}/${tagId}`;
  },
  submitPollOption: `${config.DOMAIN}/api/polls/poll`,
  mapsapi: `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_MAP_KEY}&libraries=places,geometry`,
  geoLocationService: `https://www.googleapis.com/geolocation/v1/geolocate?key=${config.GOOGLE_MAP_KEY}`,
  reverseGeocodeService: `https://maps.googleapis.com/maps/api/geocode/json?latlng={{#latlng}}&language=en&key=${config.GOOGLE_MAP_KEY}`,
  mapsPinActive: 'https://cdn.wootag.com/wootag/pin_active.png',
  mapsPinInactive: 'https://cdn.wootag.com/wootag/pin_inactive.png',
  mapsDirections: 'https://www.google.com/maps/dir/?api=1&',
  getGeoLocation: (domain) => {
    let apiDomain = domain || config.DOMAIN;
    return `${apiDomain}/api/v2/geo`;
  },
  setGeoLocation: (domain) => {
    let apiDomain = domain || config.DOMAIN;
    return `${apiDomain}/api/v2/geo/cache`;
  },
  limitedOfferCodeUsed: `${getStatsEndpoint(ENV)}/api/v1/stats/offers/count?video_id={{#videoId}}&tag_id={{#tagId}}`,
  fetchRedeemCode: (domain) => {
    if (domain) {
      return `${domain}/api/v1/getoffercode`;
    } else {
      `${config.DOMAIN}/api/v1/getoffercode`
    }
  },
  getProjectVideoId: (domain, videoString) => `${domain}/project/customadunit/v2/${videoString}`,
};

export const engagementTypeMap = {
    100: 'mail',
    101: 'tel',
};

export const icons = {
    facebook: 'zmdi zmdi-facebook',
    twitter: 'zmdi zmdi-twitter',
    linkedin: 'zmdi zmdi-linkedin',
    instagram: 'zmdi zmdi-instagram',
    google: 'zmdi zmdi-google'
};

export const themes = {
    red: '#F00',
    blue: '#33b0e8',
    white: '#FFF',
    gray: '#999',
    black: '#000',

    variants: {
        light: {
            BACKGROUND: 'rgb(238, 238, 238)',
            BACKGROUND_TAGHEADER: '#f9fafc',
            TEXT: 'rgb(32, 34, 38)',
            TEXTHEADING: 'rgb(95, 101, 108)',
            TEXT_SUBHEADING: 'rgb(158, 158, 158)',
            BORDER_COLOR: '#e5e9ed',
        },
        dark: {
            BACKGROUND: 'rgb(238, 238, 238)',
            BACKGROUND_TAGHEADER: '#f9fafc',
            TEXT: 'rgb(32, 34, 38)',
            TEXTHEADING: 'rgb(95, 101, 108)',
            TEXT_SUBHEADING: 'rgb(158, 158, 158)',
            BORDER_COLOR: '#e5e9ed',
        }
    }
};

export const regex = {
    httpCheck: /^(http|https):\/\//,
    extractVideoID: /[A-Z0-9]{6}\-[A-Z0-9]{4}\-[A-Z0-9]{10}\-[A-Z0-9]{4}\-[A-Z0-9]{4}/gi,
    betweenDoubleCurlyBracesInc: /{{(.*?)}}/,
};

function getLogsEndpoint(env) {
    let host = window.location.host
    if (!!host && host.indexOf('wootag.com') !== -1) {
        return `https://${host}/api/v1/data/track/event`
    }
    return `${config.STAGING_DOMAIN}/api/v1/data/track/event`;
};

function getStatsEndpoint(env) {
    let host = window.location.host;
    if (!!host && host.indexOf('wootag.com') !== -1) {
        return `https://${host}`;
    }
    return config.STAGING_DOMAIN;
};

function getPollsEndpoint(env) {
    let host = window.location.host;
    if (!!host && host.indexOf('wootag.com') !== -1) {
        return `https://${host}/api/v1/data/polls/polls`
    }

    return `${config.STAGING_DOMAIN}/api/v1/data/polls/polls`;
};

export function setDomain(domain) {
  config.DOMAIN = domain;
};



// WEBPACK FOOTER //
// ./components/config.js